import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WidgetsService } from '../../widgets.service';
import { SearchItem } from '../../../../entities';
import { AppService } from '../../../../app.service';
import { FleetCondition } from '../../widgets.model';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';
import { DatePipe } from '@angular/common';
import { WidgetsEnlargedComponentComponent } from '../widgets-enlarged-component/widgets-enlarged-component.component';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-inspections-due-widget',
  templateUrl: './inspections-due-widget.component.html',
  styleUrls: ['./inspections-due-widget.component.scss']
})
export class InspectionsDueWidgetComponent implements OnInit, OnDestroy {
    @Input() chartid: string;
    
  @Input() passedDataSource : any;
  @Input() isInPopup: boolean = false;
    width: number = 280;
    height: number = 180;
    type: string = 'column2d';
    dataFormat: string = 'json';
    dataSource: any;
    fleetCondition: FleetCondition;
    subscriptions: Subscription[] = [];
    //widgetTriggerSubscription: Subscription;
    emptySearchSelectionQuery: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: "Evaluation X" }];
    loading: boolean = true;
    noData: boolean = false;
    enableTab:boolean=false
    constructor(private _widgets: WidgetsService,
        private _app: AppService,
        private _notification: NotificationsService,
        private datePipe: DatePipe,
        private _dialog: MatDialog) {
        this.dataSource = {
            "chart": {
                "numDivLines": "5",
                "showValues": "1",
                "rotateLabels": "1",
                "slantLabels": "0",
                "plotSpacePercent": "10",
                "paletteColors": "#958aee,#b2b606",
                "columnHoverAlpha": "80",
                "canvasBaseDepth": "5",
                "showBorder": "0",
                "showYAxisLine": "0",
                "canvasBorderAlpha": "5",
                "showLimits": "0",
                "theme": "fusion",
                "bgColor": "#ffffff",
                "yAxisValuesPadding": "5"
            },
            "data": [
                {
                    "label": "Jan",
                    "value": "2700"
                },
                {
                    "label": "Feb",
                    "value": "200"
                },
                {
                    "label": "Mar",
                    "value": "680"
                },
                {
                    "label": "Apr",
                    "value": "1025"
                },
                {
                    "label": "Apr",
                    "value": "1025"
                },
                {
                    "label": "Jul",
                    "value": "1200"
                },
                {
                    "label": "Aug",
                    "value": "2400"
                },
                {
                    "label": "Sep",
                    "value": "2800"
                },
                {
                    "label": "Oct",
                    "value": "1584"
                },
                {
                    "label": "Nov",
                    "value": "359"
                },
                {
                    "label": "Dec",
                    "value": "1870"
                }
            ]
        };
    }

    ngOnInit() {
        this.enableTab=this._app.getEnableSearch()
        if(this.passedDataSource != null ){
            console.log("received   ", this.passedDataSource);
            this.subscriptions.push(         
              this.passedDataSource.subscribe(r=>this.loadDataToGraph(r))
              //  this.passedDataSource.forEach(c=>this.pushResult(c))
            );
            
            this.loading = false;
            if(this.isInPopup){
              this.width = 460;
              this.height = 360;
            }
          }
          else{
            this.loadWidget(this._app.getLastSelectionSearchItems());
          }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => {
            if ( s!=undefined &&!s.closed)
                s.unsubscribe();
        });
        //this.widgetTriggerSubscription.unsubscribe();
    }

    loadWidget(searchSelection: SearchItem[]) {
        this.loading = true;
        this.subscriptions.push(this._widgets.getInspectionDueByToday(searchSelection).subscribe(r => {
            this.dataSourceToPass = Observable.of(r);
            this.loadDataToGraph(r);
            // this.dataSource.data = [];          
            // r.forEach(i => {
            //     if (i != null) {
            //         this.dataSource.data.push({ "label": this.datePipe.transform(i.Date, 'MMM dd'), "value": i.NumberOfInspections });
            //     }
            // });
            // this.loading = false;
        }, error => {
            this._notification.error('Error', 'Failed to load inspection due. '); console.log(error);
        }));
    }

    loadDataToGraph(r){
        this.dataSource.data = [];          
        r.forEach(i => {
            if (i != null) {
                this.dataSource.data.push({ "label": this.datePipe.transform(i.Date, 'MMM dd'), "value": i.NumberOfInspections });
            }
        });
        this.loading = false;
    }

    dataSourceToPass :any;
    openWithANewPopup(){
        let dialogRef = this._dialog.open(WidgetsEnlargedComponentComponent, {
            panelClass: 'removeModalOverflow',
            data: {
              chartId: this.chartid,
              dataSource: this.dataSourceToPass,
              chartTitle: "Inspections due",     
            }
          });
      
          dialogRef.afterClosed().subscribe(r => {
      
          });
      }
}